import type { ReactNode } from 'react'
import './PageHeader.css'
import { ThemeMenu } from './ThemeMenu'

export type PageHeaderTone = 'scenario' | 'list' | 'flow' | 'neutral'

interface PageHeaderProps {
  title: string
  subtitle?: string | ReactNode
  onBack?: () => void
  backLabel?: string
  actions?: ReactNode
  tone?: PageHeaderTone
  kind?: string
  kindIcon?: ReactNode
  showKindLabel?: boolean
  badge?: string
}

export function PageHeader({ 
  title, 
  subtitle, 
  onBack, 
  backLabel = 'Back',
  actions,
  tone = 'neutral',
  kind,
  kindIcon,
  showKindLabel = false,
  badge 
}: PageHeaderProps) {
  return (
    <header className={`app-header page-header page-header--${tone}`}>
      <div className="header-content">
        {onBack && (
          <button onClick={onBack} className="back-btn">
            ← <span className="back-btn-text">{backLabel}</span>
          </button>
        )}
        
        <div className="page-title-wrapper">
          {kindIcon && (
            <span className="page-kind-icon" title={kind} aria-label={kind}>
              {kindIcon}
              {kind && !showKindLabel && <span className="sr-only">{kind}</span>}
            </span>
          )}
          {kind && showKindLabel && (
            <span className="page-kind-label" title={kind}>
              {kind}
            </span>
          )}
          <h1 className="page-title">{title}</h1>
          {badge && (
            <span className="page-badge" title={badge}>
              {badge}
            </span>
          )}
          {subtitle && (
            <div className="page-subtitle">
              {subtitle}
            </div>
          )}
        </div>

        <div className="header-actions">
          <ThemeMenu />
          {actions}
        </div>
      </div>
    </header>
  )
}
